export default __webpack_public_path__ + "static/media/no-marble-modal-bg.6b6cf6dc.png";